import axios from 'axios';
import { DetailCategory, SummaryCategory, Filter } from 'models/response';
import { trackPromise } from 'react-promise-tracker';

import { KPI } from '../utils/constants';
import { CategoryDetailsFilters, KpiCategoryFilterConfiguration, SummaryKpiFilters } from 'models/request';

/**
 * This API returns KPI summary categories based on the provided filters.
 * @param {SummaryKpiFilters} body - The filters for fetching summary KPI data.
 * @return {Promise<AxiosResponse<SummaryCategory[]>>}
 */
const getSummary = (body: SummaryKpiFilters) =>
  trackPromise(axios.post<SummaryCategory[]>(`${KPI}/summary`, body), 'module');

/**
 * This API returns details of a specific category based on the provided filters and category id.
 * @param {CategoryDetailsFilters} body - The filters for fetching category details.
 * @return {Promise<AxiosResponse<DetailCategory[]>>}
 */
const getCategoryDetails = (body: CategoryDetailsFilters) =>
  trackPromise(axios.post<DetailCategory[]>(`${KPI}/category`, body), 'module');

const getKpiFilterConfiguration = () => trackPromise(axios.get<Filter[]>(`${KPI}/kpiFilterConfiguration`), 'module');

const getCategoryFiltersConfiguration = ({ idCategory }: { idCategory: number }) =>
  trackPromise(
    axios.get<KpiCategoryFilterConfiguration[]>(`${KPI}/getCategoryFiltersConfiguration`, { params: { idCategory } }),
    'module',
  );

export default {
  getSummary,
  getCategoryDetails,
  getKpiFilterConfiguration,
  getCategoryFiltersConfiguration,
};
